import { takeLatest, call, put, select } from 'redux-saga/effects';
import _ from 'lodash';
import DomPurify from 'dompurify';
import axios from '../axiosConfig';
import {
  saveBrochureRequest,
  saveBrochureResponse,
  updateBrochurePriceRequest,
} from '../../slices/brochure';
import formatTripRequest from '../../../helpers/formatTripRequest';
import { priceSuccess } from '../../slices/cruise';
import getPriceBreakdownsFromBrochureTrip from '../../../helpers/getPriceBreakdownsFromBrochureTrip';
import getHotelPriceDisplayPreference from '../../../helpers/selectors/getHotelPriceDisplayPreference';

function* saveBrochureWorker({
  payload: {
    brochureId,
    savedBrochureId,
    createdFor,
    trips,
    emailRecipients,
    emailSubject,
    fromEmail,
    emailMessage,
    doUpdatePriceOnPageLoad,
    doSendCopyToAgent,
    doShowPricing,
    resultsPageUrl,
    doSaveToDatabase,
    doAllowBook,
    editorHTML,
    editorJSON,
    doShowBrochureEditor,
    templateId,
  },
}) {
  try {
    const url = '/brochure/save';
    const { email: loggedInUserEmail } = yield select((store) => store.user);
    const filters = yield select((store) => store.tripSearch.searchObj.cruise.filters);
    // const staterooms = yield select((store) => store.tripSearch.searchObj.staterooms);
    const hotelRateDisplayPreference = yield select(getHotelPriceDisplayPreference(true));
    const config = {
      method: 'post',
      url,
      data: JSON.stringify({
        trips: _.map(Object.values(trips), (trip) =>
          formatTripRequest({
            trip: {
              ...trip,
              resultsPageUrl,
            },
            filters,
            staterooms: trip?.staterooms ?? trip?.roomSearchInput,
          }),
        ),
        brochureId: savedBrochureId,
        loggedInUserEmail,
        createdFor,
        emailRecipients,
        emailSubject,
        fromEmail,
        emailMessage,
        doUpdatePriceOnPageLoad,
        doSendCopyToAgent,
        doShowPricing,
        hotelRateDisplayPreference,
        doSaveToDatabase,
        doAllowBook,
        editorHTML:
          doShowBrochureEditor && editorHTML
            ? DomPurify.sanitize(editorHTML).replace(/(src|href)="\/\//g, '$1="https://')
            : '',
        editorJSON: doShowBrochureEditor ? editorJSON : '',
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);

    yield put(
      saveBrochureResponse({
        brochureId,
        response: data,
        doSaveToDatabase,
        templateId,
      }),
    );

    if (data && data.id && data.trips) {
      const params = new URLSearchParams(window?.location?.search);
      const brochureIdFromUrl = params?.get('brochureId');
      if (doUpdatePriceOnPageLoad && !brochureIdFromUrl && doSaveToDatabase) {
        yield put(updateBrochurePriceRequest({ id: data.id }));
      } else {
        // TODO: this line of code repeats in saveBrochure. refactor it
        for (let i = 0; i < data.trips.length; i += 1) {
          yield put(priceSuccess(getPriceBreakdownsFromBrochureTrip(data.trips[i])));
        }
      }
    }
  } catch (error) {
    let errorMessage = 'We could not save this proposal. Please try again.';
    if (error && error.response && error.response.data) {
      const { title, detail } = error.response.data;
      errorMessage = detail || title || errorMessage;
    }
    yield put(
      saveBrochureResponse({
        error: errorMessage,
        brochureId,
        doSaveToDatabase,
      }),
    );
  }
}

function* saveBrochureWatcher() {
  yield takeLatest(saveBrochureRequest.toString(), saveBrochureWorker);
}

export default saveBrochureWatcher;
